import { Autocomplete, Button, CircularProgress, Divider, FormLabel, Grid, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSupplierStore } from "../../../hooks/useSupplierStore";
import { useSearcherStore } from "../../../hooks/useSearcherStore";
import { CustomSnackbar } from "../../../components/common/CustomSnackbar/CustomSnackbar";
import CloseIcon from '@mui/icons-material/Close';
import { useTicketStore } from "../../../hooks/useTicketStore";
import { useShoppingCartStore } from "../../../hooks/useShoppingCartStore";
import { useAuthStore } from "../../../hooks/useAuthStore";

interface CustomerV3Props {
    handleCloseContent: () => void
}

export const CustomerV3: FC<CustomerV3Props> = (props) => {
    const { handleCloseContent } = props

    const navigate = useNavigate()
    const { user } = useAuthStore()
    const { selectedCustomer, setSelectedCustomer } = useSearcherStore()
    const { supppliers, getSuppliers } = useSupplierStore()
    const { createTicket } = useTicketStore()
    const { shoppingcart, selectedTypeDocument, selectedSaleChannel, selectedWayToPay,
        assingCustomer } = useShoppingCartStore()

    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        getCustomerApi()
    }, [])

    useEffect(() => {
        if (shoppingcart[0] && shoppingcart[0].idcustomer !== null && supppliers.length > 0) {
            const customer = supppliers.find(customer => customer.id === shoppingcart[0].idcustomer)
            setSelectedCustomer(customer || null)
        }
    }, [shoppingcart, supppliers])

    const getCustomerApi = async () => {
        setLoading(true)
        await getSuppliers({ type: 1 })
        setLoading(false)
    }

    const onChangeCustomer = async (rowSelected: any) => {
        setSelectedCustomer(rowSelected)

        if (shoppingcart[0] && shoppingcart[0].id) {
            await assingCustomer(shoppingcart[0].id, { iduser_created: user.id, idcustomer: (rowSelected?.id || null) })
        } else {
            if (rowSelected !== null) CustomSnackbar('success', 'Cliente seleccionado: ' + rowSelected.name_rz)
        }
    }

    const onGenerateTicket = async () => {
        if (!selectedTypeDocument) return CustomSnackbar('warning', 'Seleccione un tipo de documento')
        if (!selectedSaleChannel) return CustomSnackbar('warning', 'Seleccione un canal de venta')
        if (!selectedWayToPay) return CustomSnackbar('warning', 'Seleccione una forma de pago')

        const payload: any = {
            idshopping_cart: shoppingcart[0].id,
            idtype_document: selectedTypeDocument.id,
            idsale_channel: selectedSaleChannel.id,
            idway_to_pay: selectedWayToPay.id,
            customer_rut: selectedCustomer?.rut,
            customer_name: selectedCustomer?.name_rz
        }
        const response = await createTicket(payload)
        if (response.id) navigate(`/preview-document/${response.id}`)
    }

    return (
        <div style={{ width: '80%' }}>
            <Grid style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                <Typography>Datos del cliente</Typography>
                <Tooltip title={'Cerrar panel'}>
                    <IconButton onClick={() => handleCloseContent()}>
                        <CloseIcon fontSize='medium' style={{ color: '#91CBF9' }} />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Divider />
            <Grid container spacing={2} style={{ marginTop: '10px' }}>
                <Grid item xs={12}>
                    <FormLabel sx={{ color: '#000000' }}>RUT:</FormLabel>
                    <Autocomplete
                        disablePortal
                        id="combo-box-customer"
                        value={selectedCustomer}
                        options={loading ? [] : supppliers}
                        getOptionLabel={(option) => option.rut || ""}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        fullWidth
                        renderInput={(params) => <TextField {...params} size="small"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {loading && <CircularProgress color="inherit" size={20} />}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }} />}
                        onChange={(e, newValue) => {
                            onChangeCustomer(newValue);
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormLabel sx={{ color: '#000000' }}>Razón social / Nombre:</FormLabel>
                    <TextField
                        id="name_rz"
                        type="text"
                        name="name_rz"
                        fullWidth
                        size="small"
                        value={selectedCustomer?.name_rz || ''}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                </Grid>

                <Divider sx={{ margin: '20px 0px 10px 0px' }} />
                <Grid container sx={{ marginTop: '20px', justifyContent: 'flex-end' }}>
                    <Button
                        sx={{ backgroundColor: '#91CBF9', borderRadius: '10px', color: '#ffffff', height: '25px', padding: '6px 16px', textTransform: 'none', width: 180, "&:hover": { backgroundColor: "#91CBF9" } }}
                        onClick={() => onGenerateTicket()}
                        disabled={loading}
                    >
                        Generar documento
                    </Button>
                </Grid>
            </Grid>
        </div>
    )
}